export default "__VITE_ASSET__DxR3Iv8L__"